import { render, staticRenderFns } from "./FormProtocolType.vue?vue&type=template&id=1bbf1ba6"
import script from "./FormProtocolType.vue?vue&type=script&lang=js"
export * from "./FormProtocolType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports